import * as React from 'react';
import { createContext, useContext } from 'react';

import { useLayer } from '@coursera-web/statsig';

type NavAiSparkleExperimentContextType = {
  showNavAiSparkle: boolean;
};

const NavAiSparkleExperimentContext = createContext<NavAiSparkleExperimentContextType>({
  showNavAiSparkle: false,
});

export const useNavAiSparkle = () => {
  return useContext(NavAiSparkleExperimentContext);
};

const NavAiSparkleExperimentProvider = ({ children }: React.PropsWithChildren) => {
  const layer = useLayer('global-nav-sparkle-test-layer');
  const showNavAiSparkle = layer.get('show-global-nav-sparkle', false);
  return (
    <NavAiSparkleExperimentContext.Provider value={{ showNavAiSparkle }}>
      {children}
    </NavAiSparkleExperimentContext.Provider>
  );
};

export default NavAiSparkleExperimentProvider;
